import ".././styles/BoardmemberCard.css";
function BoardmemberCard({image, name, position, description}) {
    return(
        <div className="boardmember-card">
            <img className="boardmember-picture" src={image} alt=""></img>
            <div className="boardmember-details shadow2">
                <h3 className="boardmember-name">
                    {name}
                </h3>
                <h3 className="boardmember-position">
                    {position}
                </h3>
                <p className="boardmember-description">
                    {description}
                </p>
            </div>
        </div>
    );
}

export default BoardmemberCard;